import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TabProductCategoryList } from '@component/TabProductCategoryList';
import { noProduct } from '@app/react/const/products/noProduct';
import { reduceProductWithCategory } from '@app/react/common/Function';
import { PartsProduct } from '@app/react/const/type';
import { OnSelectProductHandler } from '@app/react/uikit';
import type { AppState } from '@app/react/reducer';

const selectPartsData = (state: AppState): Array<PartsProduct> => (
    state.APIData.featherinside?.partsData ?? []
);

interface Props {
    selectedProduct: PartsProduct | null;
    onSelectProduct: OnSelectProductHandler;
    allDisabled?: boolean;
}

export const FeatherinsideTabProductCategoryListContainer: FC<Props> = ({
    selectedProduct,
    onSelectProduct,
    allDisabled,
}) => {
    const partsData = useSelector(selectPartsData);

    const viewData = useMemo(() => reduceProductWithCategory(partsData), [partsData]);

    return (
        <TabProductCategoryList
            noProduct={noProduct}
            viewData={viewData}
            selectedProduct={selectedProduct}
            onSelectProduct={onSelectProduct}
            allDisabled={allDisabled}
        />
    );
};
